import { UserTestInfo } from "./UserTestInfo";


export const ReadingTestStart = ()=>{
    return (
        <div className="subpage">
            <div id="contents" className="list_page reading_test">
                <div className="sub_header">
                    <div className="inner">
                        <div className="v_align">
                            <p>독서 태도/흥미/학업성취도를 파악하고 이해한 다음, 관심과 성향에 맞게 안내된 도서를 읽습니다. 즐거운 독서를 경험하면 독서태도에 좋은 영향을 주고 독서이력이 쌓이는 과정이 반복되어 발전을 기대할 수 있습니다.</p>
                            <p className="alert_text"><i className="icon fas fa-exclamation-circle"></i> 진단 진행 시 제한 시간은 없습니다.</p>
                        </div>
                    </div>
                </div>
                <div className="inner">
                    <UserTestInfo />

                    <div className="section pdT0">
                        <div className="row">
                            <div className="col8 test_guide clear">
                                <div className="type type1">
                                    <p className="title"><strong>기본진단</strong></p>
                                    <ul className="bullet_list">
                                        <li>독서 태도 (10문항)</li>
                                        <li>독서 흥미 (12문항)</li>
                                        <li>독서 성취도 (8문항)</li>
                                    </ul>
                                </div>
                                <div className="type type2">
                                    <p className="title"><strong>심화진단</strong></p>
                                    <ul className="bullet_list">
                                        <li>어휘력, 내용이해력 (5문항)</li>
                                        <li>추론 능력, 판단력, 분석력 (5문항)</li>
                                        <li>창의력, 문제해결력 (5문항)</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col4 infographic">
                                <img src={`${process.env.PUBLIC_URL}/images/contents/test_infographic.png`} alt="독서 이력 쌓기 : 태도, 흥미, 발견, 이해, 안내" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

